import axios from "axios";
import authHeader from '../../../authheader'

const PEREINSTATEMENTURL = process.env.REACT_APP_APIURL + "/api/IndividualPeReinstatement";



const getBoardRecommendations = (reinstatementId) => {
    return axios.get(`${PEREINSTATEMENTURL}/boardrecommendations`, { headers: authHeader(), params: { reinstatementId } });
}
const getBoardResponses = (reinstatementId) => {
    return axios.get(`${PEREINSTATEMENTURL}/boardmemberresponses`, { headers: authHeader(), params: { reinstatementId } });
}
const postBoardRecommendation = (data) => {
    return axios.post(`${PEREINSTATEMENTURL}/boardrecommendation`, data, { headers: authHeader() });
}
const postBoardResponse = (data) => {
    var header = authHeader();
    header['Content-Type'] = 'multipart/form-data';
    return axios.post(`${PEREINSTATEMENTURL}/boardmemberresponse`, data, { headers: { ...header } });
}
export default {
    getBoardRecommendations,
    getBoardResponses,
    postBoardRecommendation,
    postBoardResponse
}